export enum NestedNodeType {
    VIDEO,
    QUESTION,
    TEXT_ANSWERS,
    VOICE_ANSWERS,
    IMAGE,
    AUDIO,
    TEXT_SLIDE,
    INFOS
}